import { render, staticRenderFns } from "./CompetitorRatingTableRow.vue?vue&type=template&id=438e9592&"
import script from "./CompetitorRatingTableRow.vue?vue&type=script&lang=js&"
export * from "./CompetitorRatingTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports